module.exports = __webpack_public_path__ + "img/goods_cj.ea1517f5.svg";